import { z } from 'zod';
import { DIAPER_KINDS, DIAPER_CONSISTENCIES, DIAPER_COLORS } from '../constants.ts';

export const diaperKindSchema = z.enum(DIAPER_KINDS);
export const diaperConsistencySchema = z.enum(DIAPER_CONSISTENCIES);
export const diaperColorSchema = z.enum(DIAPER_COLORS);

export const diaperCreateSchema = z.object({
  occurred_at: z.number().int().optional(),
  kind: diaperKindSchema,
  consistency: diaperConsistencySchema.nullable().optional(),
  color: diaperColorSchema.nullable().optional(),
  leak: z.boolean().optional(),
  notes: z.string().max(2000).nullable().optional(),
});

export const diaperPatchSchema = diaperCreateSchema.partial();

export type DiaperCreateInput = z.infer<typeof diaperCreateSchema>;
export type DiaperPatchInput = z.infer<typeof diaperPatchSchema>;
